/**
 * Created by yqr on 2018/4/13.
 */
import Vue from 'vue'

export let road = new Vue()



// WEBPACK FOOTER //
// ./src/road.js